import React from 'react';

export default () => (
  <div className={'history-action-item'}>
    <div>Coaching Requested</div>
  </div>
);
